import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

export default function Journeys() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  useEffect(() => {
    api("/api/packages").then(setItems).catch((err) => setError(err.message));
  }, []);
  return (
    <Layout>
      <Seo
        title="Sri Lanka Tour Packages"
        description="Private Sri Lanka tour packages from 3 to 7 days, including Sigiriya, Kandy, Ella, Yala, and Colombo."
        path="/journeys"
      />
      <header className="page-hero">
        <div className="wrap">
          <p className="eyebrow">Our packages</p>
          <h1>Journeys</h1>
          <p>Starting prices per person, in US dollars. The shape is yours to change.</p>
        </div>
      </header>
      <section className="section">
        <div className="wrap card-grid">
          {error ? <p className="error">{error}</p> : null}
          {items.map((item) => (
            <Link key={item._id} to={`/journeys/${item.slug}`} className="package-card" style={{ backgroundImage: `url(${item.heroImage})` }}>
              <div>
                <p className="eyebrow">{item.days} days · {item.currency} {item.price}</p>
                <h3>{item.title}</h3>
                <p>{item.region}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
}
